import { render } from "./App.vue?vue&type=template&id=1361d3bd"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1361d3bd&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_91df7c0921f9e575f6107cb232f4ee79/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__